import { Component } from 'react';
import {actions, Form} from 'forms/rrf';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import RequiredPasswordMaskInput from '../../common/form/elements/required-password-mask-input';
import SecurityQuestionAnswer from '../../common/form/user/security-question-answer-input';
import PageTitle from '../../common/page-title/index';
import ArrowButton from '../../common/button-arrow';
import {updateSecurityQuestionsForAdmin} from '../../../actions/update-security-questions';
import {getQuestions} from '../../../actions/about-you';

import './update-security-questions.css';

class UpdateSecurityQuestions extends Component {
  state = {};
  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };
  onSaveClicked = (payload) => {
    this.props.dispatch(actions.submitFields('deep.updateSecQ.user', updateSecurityQuestionsForAdmin('/admin/my-profile', payload)));
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(getQuestions());
  }

  render() {
    return (
      <Form
        model="deep.updateSecQ.user"
        onSubmit={this.onSaveClicked}
      >
        <Container fluid className="update-security-questions">
          <Row>
            <Col md={12}>
              <PageTitle>
                Update security questions
              </PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RequiredPasswordMaskInput
                controlId="currentPassword"
                inputType="password"
                label="Please confirm password to make changes to security questions"
                model=".current_password"
                autoComplete="new-password"
              />

              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer1"
                answerModel=".security_answers_attributes[0].answer"
                questionControlId="userSecurityQuestion1"
                questionModel=".security_answers_attributes[0].security_question_id"
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
              />

              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer2"
                answerLabel="Security answer 2"
                answerModel=".security_answers_attributes[1].answer"
                answerPlaceHolder="Security answer 2"
                questionControlId="userSecurityQuestion2"
                questionLabel="Security question 2"
                questionModel=".security_answers_attributes[1].security_question_id"
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  questions: state.aboutYou.questions,
});

export default connect(mapStateToProps)(UpdateSecurityQuestions);
